import {PropsWithChildren} from "react";

type Props = PropsWithChildren<{

}>;
export const LimitedWidth = ({children}: Props) => {
    return <div className='client-content'>
        {children}
    </div>
}
